export default "__VITE_ASSET__ef606977__"